import { Type, Enum } from 'hello-type' // Check datatypes from API stream

export const searchItemList = new Type({
  id: Number,
  name: String,
  resourceId: String,
  type: Enum('VM', 'SRV', 'NWS', 'DOM', 'ACFG', 'SCFG')
})
